/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { ScreenControllerTypes } from '../../core/navigation/ScreenControllerTypes';
import { hideAntiburnOsd, resetAntiburnTimeout } from '../antiburnosd/antiburnosd.reducers';
import {
    clearSystemHealthStatsInterval,
    logSystemHealthStats,
    setSystemHealthStatsInterval,
} from '../healthstats/systemhealthstats.reducers';
import {
    onAppPauseVideoPlayer,
    onAppResumeVideoPlayer,
} from '../videoplayer/navigation/videoplayernavigation.reducers';
import { setAppVisibilityStateAction } from './visibilityevents.actions';
import { SET_VISIBILITY_STATE } from './visibilityevents.types';
import { VisibilityState } from './visibilitystate';
import { checkAuthentication } from '../signin/signin.reducers';
import { VuLogger } from '../../core/logging';

const initialState: {
    visibilityState: VisibilityState;
} = {
    visibilityState: VisibilityState.ON_RESUME,
};

const visibilityEventsReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_VISIBILITY_STATE:
            return {
                ...state,
                visibilityState: payload.visibilityState,
            };

        default:
            return state;
    }
};

export const setAppVisibilityState = (visibilityState: VisibilityState) => (dispatch: Function) => {
    dispatch(setAppVisibilityStateAction(visibilityState));
};

export const onPauseEvent = () => (dispatch: Function, getState: Function) => {
    dispatch(setAppVisibilityStateAction(VisibilityState.ON_PAUSE));
    const { screenController } = getState().screens;

    VuLogger.logAppExitEvent(VuLogger.AppExitActions.SUSPEND);
    dispatch(logSystemHealthStats());
    dispatch(clearSystemHealthStatsInterval());

    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onAppPauseVideoPlayer());
            break;

        case ScreenControllerTypes.ANTIBURN_SCREEN:
            dispatch(hideAntiburnOsd());
            break;

        default:
    }
};

export const onResumeEvent = () => (dispatch: Function, getState: Function) => {
    checkAuthentication();
    dispatch(setAppVisibilityStateAction(VisibilityState.ON_RESUME));
    const { screenController } = getState().screens;
    dispatch(resetAntiburnTimeout());
    dispatch(setSystemHealthStatsInterval());
    switch (screenController) {
        case ScreenControllerTypes.GUIDE:
            break;

        case ScreenControllerTypes.VIDEO_PLAYER:
            dispatch(onAppResumeVideoPlayer());
            break;

        default:
    }
};

export default visibilityEventsReducer;
